<template>
  <QuoteSlider
    v-if="carousel.type === 'Quote Slider'"
    :slides="carousel.slides"
  />
</template>

<script>
import QuoteSlider from "./QuoteSlider.vue";

export default {
  props: {
    carousel: {
      type: Object,
      required: true
    }
  },
  components: { QuoteSlider }
};
</script>
